import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

import { AdditionalShopping } from '__generated__/api';

export class AdditionalShoppingStore extends Store {
  @observable public additionalShopping?: AdditionalShopping[];

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
